var render = function render(_c, _vm) {
  return _c(
    "header",
    {
      staticClass: "app-header padding-y-md",
      staticStyle: {
        "background-color": "var(--white)",
        "--button-background": "transparent",
        "--button-hover-background": "transparent",
        "--button-margin-bottom": "0",
        "--button-padding": "var(--spacing-2xs) var(--spacing-md)",
        "--button-color": "var(--fa-md-gravy)",
        "--button-hover-color": "var(--fa-dk-blue)",
      },
      attrs: { id: "header" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass:
              "wrap-app-header position-relative display-flex flex-items-center flex-content-between size-lg tablet:size-md",
          },
          [
            _c(
              "site-link",
              {
                staticClass: "wrapper-logo-flag-animated button flat",
                attrs: { to: { name: "home" } },
              },
              [
                _c("owa-logo-flag"),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("Font Awesome"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("action", function () {
              return [
                _c(
                  "site-link",
                  {
                    staticClass: "button flat",
                    attrs: {
                      to: { name: "support" },
                      "aria-label": "Support",
                      "data-balloon-pos": "left",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.parent.$posthog.capture(
                          "support_link_click",
                          { context: "page_header_simple" }
                        )
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: {
                        icon: _vm.parent.$v7.regular.faHeadset,
                        size: "xl",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Support")]),
                  ],
                  1
                ),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }